import { Events } from '@/services/Events';
// @ts-expect-error three/addons has no bundled types for GLTFLoader
import { GLTFLoader, type GLTF } from 'three/examples/jsm/loaders/GLTFLoader';

// Cached glTF loader — one entry per URL. Cleared by ThreeEngine3D on detach, which disposes
// the cached GLTF's geometry.
class ModelLoader {
    private static _cache = new Map<string, Promise<GLTF>>();

    private static _loader = new GLTFLoader();

    static loadModel(path: string): Promise<GLTF> {
        const cached = ModelLoader._cache.get(path);
        if (cached) {
            return cached;
        }
        const name = _getName(path);
        const promise = new Promise<GLTF>((resolve, reject) => {
            Events.emit('loading-start', name);
            ModelLoader._loader.load(
                path,
                (gltf: GLTF) => resolve(gltf),
                (event: ProgressEvent) => {
                    const progress = (event.loaded / event.total) * 100;
                    Events.emit('loading-progress', { name, progress });
                },
                (error: unknown) => reject(new Error(String(error))),
            );
        });
        promise.then(() => Events.emit('loading-end', name)).catch(() => {});
        ModelLoader._cache.set(path, promise);
        return promise;
    }

    static clear(): void {
        ModelLoader._cache.clear();
    }
}

function _getName(path: string): string {
    const file = path.split('/').pop() ?? '';
    return file.split('.')[0];
}

export { ModelLoader };
